module.exports = __webpack_public_path__ + "static/media/raiahui-friends.097fafec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/raiahui-friends.jpg
// module id = 231
// module chunks = 0